import {
    BASE_URL
} from '../../config';
import {
    HIDE_REPORT_MODAL,
    SHOW_REPORT_MODAL,
    GET_DISTRIBUTORS_REPORTS,
    UPDATE_DISTRIBUTOR_REPORT,
    GET_SUPPLIER_REPORTS,
    GET_CASHBACK_REPORTS,
    GET_PROBLEMATIC_ORDERS,
    REGENERATE_REPORTS
} from "./finance.actionsTypes";
import { loadingAction } from '../../components/loading/loading.action';
import { GET_REGENERATE_PROBLEMATIC_REPORTS_TYPE } from '../../components/loading/loading.actionTypes';

import axios from 'axios';
import Notifier from '../../components/message/Notifier';

const formatMaxAndMinTime = (params) => {
    params.minDate = new Date(params.minDate).getTime();
    params.maxDate = new Date(params.maxDate).getTime();
    return params;
};

export const getTurnover = (params, callback) => {
    return loadingAction((dispatch, cb) => {
        params = formatMaxAndMinTime(params);
        axios.get(`${BASE_URL}report/turnover`, {
            params
        }).then((response) => {
            if (response.data) {
                if ('function' === typeof callback) {
                    callback(response.data);
                }
                cb();
            }
        });
    });
};

export const getSOLD_ITEMS = (params, callback) => {
    return loadingAction((dispatch, cb) => {
        params = formatMaxAndMinTime(params);
        axios.get(`${BASE_URL}report/sold`, {
            params
        }).then((response) => {
            if (response.data) {
                if ('function' === typeof callback) {
                    callback(response.data);
                }
                cb();
            }
        });
    });
};

export const distributorReport = (params, callback) => {
    return loadingAction((dispatch, cb) => {
        params = formatMaxAndMinTime(params);
        axios.get(`${BASE_URL}report/distributor`, {
            params
        }).then((response) => {
            if ('function' === typeof callback) {
                callback(response.data);
            }
            if (!response.data || !response.data.length) {
                Notifier.warning('_no_report_for_the_selected_time_period_');
            }
            dispatch({
                type: GET_DISTRIBUTORS_REPORTS,
                distributorReport: response.data || []
            });
            cb();
        });
    });
};

export const getInvoice = (isNewXML, vatExempt, params, callback) => {
    return loadingAction((dispatch, cb) => {
        params = {
            ...formatMaxAndMinTime(params),
            ...(vatExempt === true ? { vatExempt: true } : {}),
        };
        axios.get(`${BASE_URL}v2/order/invoice/${isNewXML}`, {
            params
        }).then((response) => {
            if (response.data) {
                if ('function' === typeof callback) {
                    callback(response.data);
                }
                cb();
            } else {
                if ('function' === typeof callback) {
                    callback([]);
                }
                cb();
            }
        }).catch((error) => {
            console.error('Error fetching invoice:', error);
            if ('function' === typeof callback) {
                callback([]);
            }
            cb(error);
        });
    });
};

export const supplierReport = (params, callback) => {
    return loadingAction((dispatch,cb) => {
        params = formatMaxAndMinTime(params);
        axios.get(`${BASE_URL}report/supplier`, {
            params
        }).then((response) => {
            if ('function' === typeof callback) {
                callback(response.data);
            }
            if (!response.data || !response.data.length) {
                Notifier.warning('_no_report_for_the_selected_time_period_');
                return;
            }
            dispatch({
                type: GET_SUPPLIER_REPORTS,
                supplierReport: response.data
            });
            cb();
        });
    });
};

export const updateStatus = (id, data) => {
    return (dispatch) => {
        axios.put(`${BASE_URL}report/verify/${id}`, data).then((response) => {
            dispatch({
                type : UPDATE_DISTRIBUTOR_REPORT,
                report : response.data
            });
        });
    };
};

export const showReportModal = (report) => {
    const action = Object.assign(report, {});
    action.type= SHOW_REPORT_MODAL;
    return action;
};

export const hideReportModal = () => {
    return {
        type: HIDE_REPORT_MODAL,
    };
};

export const updateDistributorReport = (shopId, report, callback) => {
    return (dispatch) => {
        axios.put(`${BASE_URL}report/${shopId}`, report).then((response) => {
            dispatch({
                type: UPDATE_DISTRIBUTOR_REPORT,
                report: response.data
            });
            if('function' === typeof callback) {
                callback(response.data);
            }
        });
    };
};

export const cashbackManagementReport = (params, cb) => {
    return loadingAction((dispatch, callback) => {
        params = formatMaxAndMinTime(params);
        axios.get(`${BASE_URL}report/cashback/`, {
            params
        }).then((response) => {
            if (!response.data || !response.data.length) {
                Notifier.warning('_no_report_for_the_selected_time_period_');
            }
            dispatch({
                type: GET_CASHBACK_REPORTS,
                cashbackReport: response.data
            });
            cb(response.data);
            callback();
        });
    });
};
export const getOrdersWithProblematicReporting = (params, cb) => {
    return loadingAction((dispatch, callback) => {
        params = formatMaxAndMinTime(params);
        axios.get(`${BASE_URL}report/problematicOrders`, {
            params
        }).then((response) => {
            if (!response.data || !response.data.length) {
                Notifier.warning('_no_orders_with_problematic_reporting_for_the_selected_time_period_');
            }
            dispatch({
                type: GET_PROBLEMATIC_ORDERS,
                problematicOrders: response.data
            });
            cb(response.data);
            callback();
        });
    });
};

export const regenerateReports = (orders, cb) => {
    return loadingAction((dispatch, callback) => {
        axios.put(`${BASE_URL}report/regenerateReports`, orders)
            .then(() => {
                dispatch({
                    type: REGENERATE_REPORTS
                });
                Notifier.success('_reports_successfully_regenerated_', '_reports_regenerated_');
                cb();
                callback();
            });
    }, GET_REGENERATE_PROBLEMATIC_REPORTS_TYPE, 'regenerateProblematicLoading');
};

export const cashbackGiftCards = (params, cb) => {
    return () => {
        axios.put(`${BASE_URL}report/cashbackGiftCards`, params)
            .then((res) => {
                if (res.status === 200) {
                    cb();
                }
            });
    };
};
